module.exports = __webpack_public_path__ + "img/nav-battery.0bd4e95b.svg";